import { render } from "./ExpenseCustomerReport.vue?vue&type=template&id=64c4b484"
import script from "./ExpenseCustomerReport.vue?vue&type=script&lang=js"
export * from "./ExpenseCustomerReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__